export const todayString = {
  en: 'TODAY',
  el: 'ΣΗΜΕΡΑ',
}

export const addDays = (date, days) => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const getDateDay = (date) => {
  return new Date(date).getDate()
}

export const getDayName = (date, local) => {
  const daysEnglish = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  const daysGreek = [
    'Κυριακή',
    'Δευτέρα',
    'Τρίτη',
    'Τετάρτη',
    'Πέμπτη',
    'Παρασκευή',
    'Σάββατο',
  ]
  return local.toLowerCase().includes('en')
    ? daysEnglish[new Date(date).getDay()]
    : daysGreek[new Date(date).getDay()]
}

export const getMonthName = (date, local) => {
  const monthEnglish = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const monthGreek = [
    'Ιανουάριος',
    'Φεβρουάριος',
    'Μάρτιος',
    'Απρίλιος',
    'Μάιος',
    'Ιούνιος',
    'Ιούλιος',
    'Αύγουστος',
    'Σεπτέμβριος',
    'Οκτώβριος',
    'Νοέμβριος',
    'Δεκέμβριος',
  ]
  return local.toLowerCase().includes('en')
    ? monthEnglish[new Date(date).getMonth()]
    : monthGreek[new Date(date).getMonth()]
}

export const getMonthShortName = (date, local) => {
  return local.toLowerCase().includes('en')
    ? date.toLocaleString('en-US', { month: 'short' })
    : date.toLocaleString('el-GR', { month: 'short' })
}

export const getDayShortName = (date, local) => {
  return local.toLowerCase().includes('en')
    ? date.toLocaleString('en-US', { weekday: 'short' })
    : date.toLocaleString('el-GR', { weekday: 'short' })
}

export const getLocaleDateString = (date) => {
  return new Date(date).toLocaleDateString()
}

export const getFormattedDate = (date, local, formatOptions) => {
  const { lang } = document.documentElement
  const locale = (local || lang).includes('en') ? 'en-US' : 'el-GR'
  return new Date(date).toLocaleDateString(locale, formatOptions)
}

export const getFormattedDateWithSeparators = (
  date,
  local,
  formatOptions,
  separator = '/'
) => {
  const dateValue = new Date(date).toLocaleDateString(local, formatOptions)
  return dateValue.split('/').join(separator)
}

export const extractFullTimeFromDate = (date) => {
  const options = {
    hour: '2-digit',
    minute: '2-digit',
  }
  const time = new Date(date.toLocaleString('en-US', options))
  return time.toLocaleTimeString('en-GB', options)
}

export const getCurrentYear = () => {
  const date = new Date()
  return date.getFullYear()
}

export const getTodayLocalString = (local) => {
  return todayString[local]
}

export const sortDates = (dates) => {
  return dates.sort((a, b) => {
    return new Date(a) - new Date(b)
  })
}

export const toISODateString = (date) => {
  return new Date(date).toISOString().split('T')[0]
}
